import { ingredients } from "../data/ingredients";
import { ingredientsTribunal } from "../data/ingredientsTribunal";
import { ingredientsBloodmoon } from "../data/ingredientsBloodmoon";

export const Ingredients = {
    withEffect(effect, options) {
        const {
            effectsVisible,
            mwOn,
            trOn,
            bmOn,
        } = options;

        const merged = [
            ...(mwOn ? ingredients : []),
            ...(trOn ? ingredientsTribunal : []),
            ...(bmOn ? ingredientsBloodmoon : []),
        ]

        const sorted = merged.sort((a, b) => a.name.localeCompare(b.name));

        return sorted.filter(it => it.effects.slice(0, effectsVisible).includes(effect));
    }
}
